import { useContext, createContext, useState, useEffect } from "react";
import { auctionHouseStorage } from "../data/storage";

type AuctionHouseContextType = {
    auctionHouses: ApiAuctionHouseEntry[] | undefined;
    setSelectedAuctionHouse: (id: number) => void;
    selectedAuctionHouse: number | undefined;
};

const AuctionHouseContext = createContext<AuctionHouseContextType>({
    auctionHouses: undefined,
    setSelectedAuctionHouse: () => {},
    selectedAuctionHouse: undefined,
});

export const useAuctionHouseCtx = (): AuctionHouseContextType => useContext<AuctionHouseContextType>(AuctionHouseContext);

const AuctionHouseProvider = ({ children }: { children: JSX.Element[] | JSX.Element }): JSX.Element => {
    const [auctionHouses, setAuctionHouses] = useState<ApiAuctionHouseEntry[]>();
    const [selectedAuctionHouse, setSelectedAuctionHouse] = useState<number>();

    useEffect(() => {
        (async () => {
            try {
                const data = await auctionHouseStorage.getData();
                setAuctionHouses(data);
                if (data[0]) setSelectedAuctionHouse(data[0].id);
                return data;
            } catch (error) {
                alert(`Failed to load auction house list: ${error}`);
            }
        })();
    }, []);

    return (
        <AuctionHouseContext.Provider value={{ auctionHouses, setSelectedAuctionHouse, selectedAuctionHouse }}>
            {children}
        </AuctionHouseContext.Provider>
    );
};

export default AuctionHouseProvider;
